import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ScheduledReportBusinessPurpose,
  ScheduledReportSensitiveAccess,
} from '../../../services/scheduled-reports/scheduled-reports.service';

export interface PayrollSensitiveReportPreviewDialogData {
  reportName: string;
  businessPurposes: ScheduledReportBusinessPurpose[];
}

export interface PayrollSensitiveReportPreviewDialogResult {
  sensitiveAccess: ScheduledReportSensitiveAccess;
}

@Component({
  selector: 'app-payroll-sensitive-report-preview-dialog',
  templateUrl: './payroll-sensitive-report-preview-dialog.component.html',
  styleUrls: ['./payroll-sensitive-report-preview-dialog.component.scss'],
})
export class PayrollSensitiveReportPreviewDialogComponent {
  private readonly identifierPattern = /^[A-Za-z0-9@._:+-]+$/;

  protected readonly referenceTypes = [
    { value: 'jira', label: 'Jira ticket' },
    { value: 'case', label: 'Support or operations case' },
    { value: 'approved_request', label: 'Approved request' },
  ];

  protected readonly form = this.formBuilder.group({
    businessPurposeCode: [
      '',
      [Validators.required, Validators.maxLength(64), Validators.pattern(this.identifierPattern)],
    ],
    referenceType: [
      '',
      [Validators.required, Validators.maxLength(32), Validators.pattern(this.identifierPattern)],
    ],
    referenceId: [
      '',
      [Validators.required, Validators.maxLength(128), Validators.pattern(this.identifierPattern)],
    ],
    revealConfirmed: [false, Validators.requiredTrue],
  });

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<
      PayrollSensitiveReportPreviewDialogComponent,
      PayrollSensitiveReportPreviewDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) protected data: PayrollSensitiveReportPreviewDialogData,
  ) {}

  protected cancel(): void {
    this.dialogRef.close();
  }

  protected submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const raw = this.form.getRawValue();
    this.dialogRef.close({
      sensitiveAccess: {
        businessPurposeCode: `${raw.businessPurposeCode || ''}`.trim(),
        referenceType: `${raw.referenceType || ''}`.trim(),
        referenceId: `${raw.referenceId || ''}`.trim(),
      },
    });
  }
}
